import { SelectBoxModel } from "src/app/model";

export interface SequentialSelectBoxModel {
  value: string;
  option: SelectBoxModel[];
}

export interface SequentialFilterModel {
  [s: string]: SequentialSelectBoxModel;
}